var map = {
	"./address.ru.json": "3eb6",
	"./archive.ru.json": "65b0",
	"./auth.ru.json": "503f",
	"./common.ru.json": "bb50",
	"./documents.ru.json": "98af",
	"./error.ru.json": "e59f",
	"./general_information.ru.json": "c4b6",
	"./mail.ru.json": "574e",
	"./main.ru.json": "d0a5",
	"./navigation.ru.json": "457c",
	"./payment.ru.json": "a6e6",
	"./payroll.ru.json": "43dc",
	"./period.ru.json": "1f89",
	"./profile.ru.json": "9942",
	"./requests.ru.json": "1354",
	"./router.ru.json": "2193",
	"./sales_tax.ru.json": "fff9",
	"./subscriptions.ru.json": "6043",
	"./tax_calendar.ru.json": "df6d",
	"./taxation.ru.json": "c91c",
	"./util.ru.json": "b4ea",
	"./wallet.ru.json": "c86e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10be";